<template>
    <div>
        <div v-if="searchAttributeList.length === 0">
            {{ $t('tableResults.searchAttributes.noResult') }}
        </div>
        <template v-if="searchAttributeList">
            <v-draggable :list="searchAttributeList" handle=".fa-arrows-alt">
                <div
                    v-for="(searchAttribute, index) in searchAttributeList"
                    :key="index"
                    class="accordion"
                    role="tablist"
                >
                    <b-card
                        no-body
                        class="mb-1"
                        v-if="searchAttribute.mode !== 'delete'"
                    >
                        <b-card-header
                            header-tag="header"
                            :class="headerClass(index)"
                            role="tab"
                            @click="$_selectSearchAttribute(index)"
                            data-toggle="collapse"
                        >
                            <em class="fa fa-arrows-alt"></em>
                            <span>{{ searchAttribute.alias }}</span>
                            <div class="float-right">
                                <a
                                    :title="$t('styling.delete')"
                                    class="pr-4"
                                    @click.stop.prevent="
                                        $_onRemoveSearchAttribute(index)
                                    "
                                >
                                    <em class="fas fa-trash-alt fa-sm"></em>
                                </a>
                                <em class="fa iconCollapseExpand"></em>
                            </div>
                        </b-card-header>
                        <b-collapse
                            :id="`accordion-${index}`"
                            accordion="searchattributes-accordion"
                            v-model="accordionState[index]"
                            role="tabpanel"
                        >
                            <b-card-body
                                v-if="accordionState[index] === true"
                                class="col-xs-10 col-md-6"
                            >
                                <!--Attribute-->
                                <x-select
                                    id="search-attr-attribute"
                                    name="search-attr-attribute"
                                    :text="$t('labelAttributeName')"
                                    v-model="searchAttribute.columnName"
                                    @changed="
                                        $_onChangedAttribute(searchAttribute)
                                    "
                                    :options="$_informationAttributesOptions"
                                    :state="
                                        searchAttribute
                                            .invalidAttributeErrorMessage
                                            .length === 0
                                    "
                                    :invalidMessage="
                                        searchAttribute.invalidAttributeErrorMessage
                                    "
                                    :simpleMode="true"
                                >
                                </x-select>
                                <!--Name-->
                                <x-input
                                    id="search-attr-name"
                                    name="search-attr-name"
                                    :text="$t('columnNameName')"
                                    v-model="searchAttribute.alias"
                                    :maxlength="50"
                                    @input="$_onInputName(searchAttribute)"
                                    :state="
                                        searchAttribute.invalidNameErrorMessage
                                            .length === 0
                                    "
                                    :invalidMessage="
                                        searchAttribute.invalidNameErrorMessage
                                    "
                                >
                                </x-input>
                                <!--Operator-->
                                <x-select
                                    v-if="searchAttribute.columnName"
                                    id="search-attr-operator"
                                    name="search-attr-operator"
                                    :text="
                                        searchAttribute.operatorEditable
                                            ? $t('labelOperatorDefault')
                                            : $t('labelOperator')
                                    "
                                    v-model="searchAttribute.operator"
                                    @changed="
                                        $_onChangedOperator(searchAttribute)
                                    "
                                    :options="
                                        $_operatorOptions(searchAttribute)
                                    "
                                    :state="
                                        searchAttribute
                                            .invalidOperatorErrorMessage
                                            .length === 0
                                    "
                                    :invalidMessage="
                                        searchAttribute.invalidOperatorErrorMessage
                                    "
                                    :simpleMode="true"
                                >
                                </x-select>
                                <!--Operator zichtbaar-->
                                <x-checkbox
                                    v-if="searchAttribute.columnName"
                                    id="search-attr-operator-visible"
                                    name="search-attr-operator-visible"
                                    class="pb-2"
                                    :text="$t('labelOperatorVisible')"
                                    v-model="searchAttribute.operatorEditable"
                                    :disabled="
                                        searchAttribute.domainType ===
                                        domainTypeConst.ALL_VALUES
                                    "
                                >
                                </x-checkbox>
                                <!--Invoer-->
                                <x-select
                                    v-if="
                                        searchAttribute.columnName &&
                                        !$_isDataTypeDateTime(searchAttribute)
                                    "
                                    id="search-attr-input"
                                    name="search-attr-input"
                                    :text="$t('labelInput')"
                                    v-model="searchAttribute.valueInput"
                                    @changed="
                                        $_onChangedValueInput(searchAttribute)
                                    "
                                    :options="
                                        $_valueInputOptions(searchAttribute)
                                    "
                                    :state="
                                        searchAttribute
                                            .invalidValueInputErrorMessage
                                            .length === 0
                                    "
                                    :invalidMessage="
                                        searchAttribute.invalidValueInputErrorMessage
                                    "
                                    :simpleMode="true"
                                >
                                </x-select>
                                <!--Domain-->
                                <x-select
                                    v-if="
                                        searchAttribute.columnName &&
                                        searchAttribute.valueInput ===
                                            valueInputTypeConst.DOMAIN
                                    "
                                    id="search-attr-domain"
                                    name="search-attr-domain"
                                    :text="$t('labelDomain')"
                                    v-model="searchAttribute.domainId"
                                    @changed="
                                        $_onChangedDomain(searchAttribute)
                                    "
                                    :options="$_domainOptions"
                                    :state="
                                        searchAttribute
                                            .invalidDomainErrorMessage
                                            .length === 0
                                    "
                                    :invalidMessage="
                                        searchAttribute.invalidDomainErrorMessage
                                    "
                                    :simpleMode="true"
                                >
                                </x-select>
                                <!--Add domain link-->
                                <div
                                    class="form-group domain-add"
                                    v-show="
                                        searchAttribute.valueInput ===
                                        valueInputTypeConst.DOMAIN
                                    "
                                >
                                    <b-link
                                        id="search-attr-domain-add"
                                        name="search-attr-domain-add"
                                        @click="
                                            $_openDomainModal(searchAttribute)
                                        "
                                    >
                                        <em class="fa fa-plus pr-1"></em
                                        >{{ $t('domainAddButton') }}
                                    </b-link>
                                </div>
                                <!--Domeinwaarden tonen middels-->
                                <x-select
                                    v-if="
                                        searchAttribute.columnName &&
                                        searchAttribute.valueInput ===
                                            valueInputTypeConst.DOMAIN &&
                                        searchAttribute.domainId
                                    "
                                    id="search-attr-domain-type"
                                    name="search-attr-domain-type"
                                    :text="$t('domainShowThrough')"
                                    v-model="searchAttribute.domainType"
                                    @changed="
                                        $_onChangedDomainType(searchAttribute)
                                    "
                                    :options="$_domainTypeOptions"
                                    :simpleMode="true"
                                    :state="
                                        searchAttribute
                                            .invalidDomainTypeErrorMessage
                                            .length === 0
                                    "
                                    :invalidMessage="
                                        searchAttribute.invalidDomainTypeErrorMessage
                                    "
                                >
                                </x-select>
                                <!--Value-->
                                <template
                                    v-if="
                                        searchAttribute.columnName &&
                                        searchAttribute.domainType !==
                                            domainTypeConst.ALL_VALUES
                                    "
                                >
                                    <label>
                                        {{
                                            `${$t('labelValue')}${$t(
                                                'labelOptional'
                                            )}`
                                        }}
                                    </label>
                                    <!-- Info for SYSDATE value -->
                                    <span
                                        v-if="
                                            $_isDataTypeDateTime(
                                                searchAttribute
                                            )
                                        "
                                        class="pl-1"
                                    >
                                        <info-button
                                            :name="`${searchAttribute.id}valueInfo`"
                                        />
                                        <tooltip
                                            :target="`${searchAttribute.id}valueInfo`"
                                            :title="
                                                $t('filterSysdateInputInfo')
                                            "
                                            :customClass="'medium'"
                                        >
                                        </tooltip>
                                    </span>
                                    <!--Value input-->
                                    <x-input
                                        v-if="
                                            searchAttribute.valueInput !==
                                            valueInputTypeConst.DOMAIN
                                        "
                                        id="search-attr-input-value"
                                        name="search-attr-input-value"
                                        v-model="searchAttribute.value"
                                        :maxlength="50"
                                        :placeholder="
                                            searchAttribute.valueInput ===
                                            valueInputTypeConst.DATEFIELD
                                                ? 'dd-mm-jjjj OF <SYSDATE>'
                                                : 'Filter waarde'
                                        "
                                    >
                                    </x-input>
                                    <!--Value domain-->
                                    <x-select
                                        v-if="
                                            searchAttribute.valueInput ===
                                            valueInputTypeConst.DOMAIN
                                        "
                                        id="search-attr-domain-value"
                                        name="search-attr-domain-value"
                                        v-model="searchAttribute.value"
                                        :options="
                                            $_domainValueOptions(
                                                searchAttribute
                                            )
                                        "
                                        :simpleMode="true"
                                    >
                                    </x-select>
                                </template>
                                <!--Hoofdlettergevoelig-->
                                <x-checkbox
                                    v-if="
                                        $_isDataTypeAlphaNumeric(
                                            searchAttribute
                                        ) &&
                                        searchAttribute.valueInput !==
                                            valueInputTypeConst.DOMAIN
                                    "
                                    id="search-attr-casesensitive"
                                    name="search-attr-casesensitive"
                                    :text="$t('caseSensitive')"
                                    v-model="searchAttribute.caseSensitive"
                                >
                                </x-checkbox>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </v-draggable>
        </template>
        <div>
            <b-link
                id="addSearchAttribute"
                name="addSearchAttribute"
                @click="$_addSearchAttribute"
            >
                <em class="fa fa-plus pr-1"></em
                >{{ $t('tableResults.searchAttributes.add') }}
            </b-link>
        </div>
        <add-domain-modal
            :launchModal="launchDomainModal"
            @modal-generated-domain="$_onModalDomainGenerated"
            @modal-domain-saved="$_onModalDomainSaved"
            :tableResultSearchAttribute="$_tableResultSearchAttribute"
        >
        </add-domain-modal>
    </div>
</template>

<script>
    import { DOMAIN_TYPE, VALUE_INPUT_TYPE } from '../../../constants';
    import {
        valueToName,
        convertToValueTextPair,
        classifyDataType,
        getRefCodes,
        filterOperatorOptions,
        arraySortAscendingFunction,
        numberSortFunction,
        onlyInLeftArray
    } from '../../../services/utilities';
    import modalMixin from '../../../components/Mixins/ModalMixin.vue';
    import InfoButton from '../../../components/InfoButton.vue';
    import Tooltip from '../../../components/Tooltip.vue';
    import XInput from '../../BaseComponents/x-input.vue';
    import XSelect from '../../BaseComponents/x-select.vue';
    import XCheckbox from '../../BaseComponents/x-checkbox.vue';
    import draggable from 'vuedraggable';
    import AddDomainModal from '../../../components/AddDomainModal.vue';

    const searchAttributeTemplate = {
        columnName: null,
        alias: '',
        caseSensitive: false,
        operator: null,
        operatorEditable: false,
        value: null,
        valueInput: null,
        domainId: null,
        domainType: null,
        domainValues: [],
        order: 0,

        dataType: '',
        classifiedDataType: '',
        mode: '',

        invalidAttributeErrorMessage: '',
        invalidNameErrorMessage: '',
        invalidOperatorErrorMessage: '',
        invalidValueInputErrorMessage: '',
        invalidDomainErrorMessage: '',
        invalidDomainTypeErrorMessage: ''
    };

    export default {
        mixins: [modalMixin],
        props: {
            layerId: { type: Number, required: true },
            layerName: { type: String, required: true },
            informationAttributes: {
                type: Array,
                required: true,
                default: () => []
            }
        },
        components: {
            'x-input': XInput,
            'x-select': XSelect,
            'x-checkbox': XCheckbox,
            'info-button': InfoButton,
            'v-draggable': draggable,
            'add-domain-modal': AddDomainModal,
            tooltip: Tooltip
        },
        data() {
            return {
                // Constants
                valueInputTypeConst: VALUE_INPUT_TYPE,
                domainTypeConst: DOMAIN_TYPE,

                // Other
                valueInputTypes: [],
                domains: [],
                domainTypes: [],

                launchDomainModal: false,
                savedSearchAttribute: null,

                searchAttributeList: [],
                accordionState: [],
                newSearchAttributeId: -1 // Startpoint for new search attributes. They get a negative ID value
            };
        },
        created() {
            this.init();
        },
        computed: {
            headerClass() {
                return (index) => {
                    return {
                        'p-1': true,
                        collapsed: !this.accordionState[index],
                        'not-collapsed': this.accordionState[index]
                    };
                };
            },
            $_informationAttributesOptions() {
                return convertToValueTextPair(
                    this.informationAttributes,
                    'attribute',
                    'alias'
                ).sort(arraySortAscendingFunction('text'));
            },
            $_operatorOptions() {
                return (searchAttribute) => filterOperatorOptions(searchAttribute);
            },
            $_valueInputOptions() {
                return (searchAttribute) => {
                    const inputTypes = this.$_getInputTypes(
                        searchAttribute.classifiedDataType
                    );
                    return convertToValueTextPair(
                        inputTypes,
                        'code',
                        'description'
                    );
                };
            },
            $_domainOptions() {
                return convertToValueTextPair(this.domains, 'id', 'name').sort(
                    arraySortAscendingFunction('text')
                );
            },
            $_domainTypeOptions() {
                return convertToValueTextPair(
                    this.domainTypes,
                    'code',
                    'description'
                );
            },
            $_domainValueOptions() {
                return (searchAttribute) => searchAttribute.domainValues;
            },
            $_isDataTypeDateTime() {
                return (searchAttribute) =>
                    searchAttribute.classifiedDataType === 'datetime';
            },
            $_isDataTypeAlphaNumeric() {
                return (searchAttribute) =>
                    searchAttribute.classifiedDataType === 'string';
            },
            $_tableResultSearchAttribute() {
                return {
                    layerName: this.layerName,
                    columnName: this.savedSearchAttribute?.columnName
                };
            }
        },
        methods: {
            async init() {
                await this.$_getRefCodes();
                await this.loadSearchAttributes();
                await this.$_loadDomains();
            },
            async $_getRefCodes() {
                // Retrieve possible value-input types
                const valueInputTypes = await getRefCodes(VALUE_INPUT_TYPE.KEY);
                this.valueInputTypes = valueInputTypes.data;

                // Retrieve possible domain types
                const domainTypes = await getRefCodes(DOMAIN_TYPE.KEY);
                this.domainTypes = domainTypes.data.filter(
                    (rf) => rf.code !== DOMAIN_TYPE.SELECT
                );
            },
            async loadSearchAttributes() {
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetTableSearchFields',
                    parameters: { Id: this.layerId }
                });

                const searchAttributes = this.$_getSynchronizedSearchAttributes(
                    result?.data,
                    this.informationAttributes
                );

                this.searchAttributeList = [...searchAttributes]
                    .map((searchAttribute) => {
                        searchAttribute.domainValues = [];
                        searchAttribute.mode = 'edit';
                        searchAttribute.invalidAttributeErrorMessage = '';
                        searchAttribute.invalidNameErrorMessage = '';
                        searchAttribute.invalidOperatorErrorMessage = '';
                        searchAttribute.invalidValueInputErrorMessage = '';
                        searchAttribute.invalidDomainErrorMessage = '';
                        searchAttribute.invalidDomainTypeErrorMessage = '';

                        this.$_setDomainValues(searchAttribute);
                        this.$_setDataType(searchAttribute);

                        return searchAttribute;
                    })
                    .sort(numberSortFunction('order'));
                this.$_collapseAllSearchAttributes();
            },
            $_getSynchronizedSearchAttributes(currentAttributes, newAttributes) {
                // comparer to determine if two columnNames are equal
                const isSameColumnName = (a, b) => a.columnName === b.columnName;

                const onlyInCurrent = onlyInLeftArray(
                    currentAttributes,
                    newAttributes,
                    isSameColumnName
                );

                // remove obsolete attributes
                return currentAttributes.filter(
                    (el) => !onlyInCurrent.includes(el)
                );
            },
            validateSearchAttributes() {
                // Check if search attributes contains error or value is empty
                this.searchAttributeList.forEach((searchAttribute) => {
                    this.$_validateAttribute(searchAttribute);
                    this.$_validateName(searchAttribute);
                    this.$_validateOperator(searchAttribute);
                    this.$_validateValueInput(searchAttribute);
                    this.$_validateDomain(searchAttribute);
                    this.$_validateDomainType(searchAttribute);
                });
                const invalidAttributes = [];
                const allFieldsValid = (searchAttribute) => {
                    const fieldsValid =
                        searchAttribute.invalidAttributeErrorMessage.length === 0 &&
                        searchAttribute.invalidNameErrorMessage.length === 0 &&
                        searchAttribute.invalidOperatorErrorMessage.length === 0 &&
                        searchAttribute.invalidValueInputErrorMessage.length ===
                            0 &&
                        searchAttribute.invalidDomainErrorMessage.length === 0 &&
                        searchAttribute.invalidDomainTypeErrorMessage.length === 0;
                    if (!fieldsValid) {
                        invalidAttributes.push(`- ${searchAttribute.alias}`);
                    }
                    return fieldsValid;
                };
                const allSearchAttributesValid =
                    this.searchAttributeList.filter(
                        (searchAttribute) =>
                            searchAttribute.mode !== 'delete' &&
                            !allFieldsValid(searchAttribute)
                    ).length === 0;
                if (!allSearchAttributesValid) {
                    this.showToast({
                        message: this.$t(
                            'tableResults.searchAttributes.incorrectInputFields',
                            [invalidAttributes.join('\n')]
                        ),
                        variant: 'danger',
                        autoHideDelay: 5000
                    });
                }
                return allSearchAttributesValid;
            },
            async saveSearchAttributes() {
                this.$_collapseAllSearchAttributes();
                return Promise.all(
                    this.searchAttributeList
                        // do not save new items that have been marked to be removed
                        // New (unsaved) items have a negative ID value
                        .filter(
                            (searchAttribute) =>
                                !(
                                    searchAttribute.id < 0 &&
                                    searchAttribute.mode === 'delete'
                                )
                        )
                        // do not save unchanged searchAttributes
                        .filter(
                            (searchAttribute) =>
                                !(searchAttribute.id > 0 && !searchAttribute.mode)
                        )
                        .map((searchAttribute, index) => {
                            // set properties
                            searchAttribute.tableSearchResultId = this.layerId;
                            searchAttribute.order = index;

                            // Remove properties before saving to database
                            delete searchAttribute.classifiedDataType;
                            delete searchAttribute.domainValues;

                            if (searchAttribute.id < 0) {
                                searchAttribute.id = 0;
                                return this.$store.dispatch('useApiData', {
                                    name: 'CreateTableSearchField',
                                    data: searchAttribute
                                });
                            }
                            if (searchAttribute.mode === 'edit') {
                                return this.$store.dispatch('useApiData', {
                                    name: 'UpdateTableSearchField',
                                    data: searchAttribute
                                });
                            }
                            if (searchAttribute.mode === 'delete') {
                                return this.$store.dispatch('useApiData', {
                                    name: 'DeleteTableSearchField',
                                    parameters: { Id: searchAttribute.id }
                                });
                            }
                            return Promise.resolve();
                        })
                );
            },
            $_addSearchAttribute() {
                this.$_collapseAllSearchAttributes();
                // A new searchAttribute has no ID value
                // Give it a negative value
                this.searchAttributeList.push({
                    ...searchAttributeTemplate,
                    id: this.newSearchAttributeId--
                });
                this.accordionState.push(true);
            },
            $_selectSearchAttribute(index) {
                const newVal = !this.accordionState[index];
                this.accordionState = this.searchAttributeList.map(
                    (format) => false
                );
                this.accordionState[index] = newVal;
            },
            $_onRemoveSearchAttribute(deleteindex) {
                const data = {
                    message: this.$t(
                        'tableResults.searchAttributes.deleteConfirmation'
                    )
                };
                this.msgBoxConfirm(data).then((confirmed) => {
                    if (confirmed) {
                        this.searchAttributeList = this.searchAttributeList.map(
                            (searchAttribute, index) => ({
                                ...searchAttribute,
                                mode:
                                    index === deleteindex
                                        ? 'delete'
                                        : searchAttribute.mode
                            })
                        );
                    }
                });
            },
            $_onChangedAttribute(searchAttribute) {
                // reset values
                searchAttribute.operator = null;
                searchAttribute.operatorEditable = false;
                searchAttribute.value = null;
                searchAttribute.valueInput = null;
                searchAttribute.caseSensitive = false;
                searchAttribute.domainId = null;
                searchAttribute.domainType = null;

                // auto fill alias
                searchAttribute.alias = valueToName(searchAttribute.columnName);
                this.$_onInputName(searchAttribute);

                // set datatype
                if (searchAttribute.columnName) {
                    this.$_setDataType(searchAttribute);
                    this.$_setValueInput(searchAttribute);
                }

                // validate
                this.$_validateAttribute(searchAttribute);
            },
            $_onInputName(searchAttribute) {
                this.$_validateName(searchAttribute);
            },
            $_onChangedOperator(searchAttribute) {
                this.$_validateOperator(searchAttribute);
            },
            $_onChangedValueInput(searchAttribute) {
                searchAttribute.domainId = null;
                searchAttribute.value = null;
                searchAttribute.domainValues = [];
                this.$_validateValueInput(searchAttribute);
            },
            async $_onChangedDomain(searchAttribute) {
                searchAttribute.value = null;
                searchAttribute.domainValues = [];
                await this.$_setDomainValues(searchAttribute);
                this.$_validateDomain(searchAttribute);
            },
            $_onChangedDomainType(searchAttribute) {
                this.$_validateDomainType(searchAttribute);
            },
            $_getInputTypes(classifiedDataType) {
                switch (classifiedDataType) {
                    case 'string':
                    case 'boolean':
                    case 'integer':
                    case 'float':
                        return this.valueInputTypes.filter((o) =>
                            [
                                VALUE_INPUT_TYPE.TEXTFIELD,
                                VALUE_INPUT_TYPE.DOMAIN
                            ].includes(o.code)
                        );
                    case 'datetime':
                        return this.valueInputTypes.filter((o) =>
                            [VALUE_INPUT_TYPE.DATEFIELD].includes(o.code)
                        );
                    default:
                        return [];
                }
            },
            async $_loadDomains() {
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetFeedbackDomainOverview'
                });
                if (result?.data) {
                    this.domains = result.data;
                }
            },
            $_collapseAllSearchAttributes() {
                this.accordionState = this.searchAttributeList.map(() => false);
            },
            $_openDomainModal(searchAttribute) {
                // The prop value of Modal needs to be changed in order to trigger
                // the watch function in AddDomainModal component
                this.launchDomainModal = !this.launchDomainModal;
                this.savedSearchAttribute = searchAttribute;
            },
            $_onModalDomainGenerated(data) {
                // add domain
                this.domains.push({
                    errorMessage: '',
                    id: data.domain.id,
                    name: data.domain.name,
                    unavailable: false
                });

                this.savedSearchAttribute.domainId = data.domain.id;
                this.$_onChangedDomain(this.savedSearchAttribute);
            },
            async $_onModalDomainSaved(data) {
                if (this.savedSearchAttribute !== null) {
                    // Set the domain id of the active filter
                    this.savedSearchAttribute.domainId = data.id;
                    // Refresh domain list
                    await this.$_loadDomains();
                    const message = this.getDomainModalMessage(data);
                    if (message) {
                        this.showToast({
                            message: message,
                            variant: 'danger',
                            autoHideDelay: 5000,
                            noCloseButton: true
                        });
                    }
                    // Change the domain selection
                    this.savedSearchAttribute.domainId = data.id;
                    this.$_onChangedDomain(this.savedSearchAttribute);
                    // Reset the saved filter
                    this.savedSearchAttribute = null;
                }
            },
            $_setValueInput(searchAttribute) {
                if (this.$_isDataTypeDateTime(searchAttribute)) {
                    searchAttribute.valueInput = VALUE_INPUT_TYPE.DATEFIELD;
                }
            },
            $_setDataType(searchAttribute) {
                const foundAttribute = this.informationAttributes.find(
                    ({ attribute }) => attribute === searchAttribute.columnName
                );
                searchAttribute.dataType = foundAttribute?.dataType;
                searchAttribute.classifiedDataType = classifyDataType(
                    foundAttribute?.dataType
                );
            },
            async $_setDomainValues(searchAttribute) {
                if (searchAttribute.domainId) {
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GetDomainKeyValues',
                        parameters: { id: searchAttribute.domainId }
                    });
                    if (result?.data) {
                        searchAttribute.domainValues = convertToValueTextPair(
                            result.data,
                            'key',
                            'value'
                        ).sort(arraySortAscendingFunction('text'));
                    } else {
                        searchAttribute.domainValues = [];
                    }
                }
            },
            $_validateAttribute(searchAttribute) {
                searchAttribute.invalidAttributeErrorMessage =
                    !searchAttribute.columnName ? this.$t('requiredField') : '';
            },
            $_validateName(searchAttribute) {
                searchAttribute.invalidNameErrorMessage = !searchAttribute.alias
                    ? this.$t('requiredField')
                    : '';
                // check if name already exists
                if (searchAttribute.alias) {
                    searchAttribute.invalidNameErrorMessage = '';
                    const found = this.searchAttributeList.find((item) => {
                        return (
                            item.id !== searchAttribute.id &&
                            item.alias.toLowerCase() ===
                                searchAttribute.alias.toLowerCase()
                        );
                    });
                    if (found) {
                        searchAttribute.invalidNameErrorMessage = this.$t(
                            'tableResults.nameInUse'
                        );
                    }
                }
            },
            $_validateOperator(searchAttribute) {
                searchAttribute.invalidOperatorErrorMessage =
                    !searchAttribute.operator ? this.$t('requiredField') : '';
            },
            $_validateValueInput(searchAttribute) {
                searchAttribute.invalidValueInputErrorMessage =
                    !searchAttribute.valueInput ? this.$t('requiredField') : '';
            },
            $_validateDomain(searchAttribute) {
                searchAttribute.invalidDomainErrorMessage =
                    searchAttribute.valueInput === VALUE_INPUT_TYPE.DOMAIN &&
                    !searchAttribute.domainId
                        ? this.$t('requiredField')
                        : '';
            },
            $_validateDomainType(searchAttribute) {
                searchAttribute.invalidDomainTypeErrorMessage =
                    searchAttribute.domainId && !searchAttribute.domainType
                        ? this.$t('requiredField')
                        : '';
            }
        }
    };
</script>

<style scoped lang="scss">
.fa-arrows-alt:hover {
    cursor: move;
}

.accordion > .card {
    overflow: initial;
}

.domain-add {
    margin-top: -15px;
}
</style>
